import { createSlice } from '@reduxjs/toolkit';
import { supplierContact } from './supplierAsyncThunk';

const supplierContactSlice = createSlice({
  name: "supplier",
  initialState: {
    payload: "",
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [supplierContact.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [supplierContact.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = action.payload.supplier;
    },
    [supplierContact.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default supplierContactSlice.reducer;